// extracted by mini-css-extract-plugin
module.exports = {"partners":"_1r-H4svZxBeSNQh-WYgag6","item":"_2ZTj7liDFIElqNL2zYtEG0"};